var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.957764H513V342.961H0V0.957764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.957764H513V114.955H0V0.957764Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.953H513V342.95H0V228.953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.676 131.064L196.902 159.461H226.762L202.605 177.013L211.832 205.41L187.676 187.86L163.519 205.41L172.746 177.013L148.59 159.461H178.449L187.676 131.064ZM325.324 131.064L334.551 159.461H364.411L340.254 177.013L349.481 205.41L325.324 187.86L301.168 205.41L310.395 177.013L286.238 159.461H316.098L325.324 131.064Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.959717)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy);
export default __webpack_public_path__ + "static/media/SY.50078f7d6caec08d22a20361ac8b8ea4.svg";
export { ForwardRef as ReactComponent };